module.exports = __webpack_public_path__ + "img/www.niche.com.664666a8.png";